import APIMapper from './APIMapper';
import ButtonController from "../../controllers/ButtonController";
import * as EntityTypes from '../constants/entityTypes';

class EntryAPIMapper extends APIMapper {
  update(change) {
    const { item, onSuccess, onError } = change;
    const widgetId = item.dependencies.get(EntityTypes.WIDGET);
    const entryId = item.dependencies.get(EntityTypes.ENTRY);

    return ButtonController.putEntry(widgetId, entryId, item.nextValue)
      .then(onSuccess)
      .catch(onError);
  }

  delete(change) {
    const { item, onSuccess, onError } = change;
    const widgetId = item.dependencies.get(EntityTypes.WIDGET);
    const entryId = item.dependencies.get(EntityTypes.ENTRY);

    return ButtonController.deleteEntry(widgetId, entryId, item.prevValue.id)
      .then(onSuccess)
      .catch(onError);
  }
}

export default new EntryAPIMapper();
